import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {
  CreatePaymentMethod,
  UpdatePaymentDetails,
} from '../../../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'

const CreateNewPaymentGateway = ({show, handleClose, edit}: any) => {
  const dispatch = useDispatch()
  const [error, setError] = useState<any>({})
  const [paymentMethod, setPaymentMethod] = useState({
    paymentGatewayName: '',
    accountName: '',
    email: '',
    status: 'active',
  })

  const handleSubmit = () => {
    if (Object.keys(Validation(paymentMethod)).length == 0) {
      if (!edit?._id) {
        dispatch(CreatePaymentMethod(paymentMethod))
        setPaymentMethod({
          paymentGatewayName: '',
          accountName: '',
          email: '',
          status: 'active',
        })
        handleClose()
      } else {
        dispatch(UpdatePaymentDetails({paymentMethod: paymentMethod, id: edit?._id}))
        setPaymentMethod({
          paymentGatewayName: '',
          accountName: '',
          email: '',
          status: 'active',
        })
        handleClose()
      }
    }
  }
  const Validation = (val: any) => {
    const errors: any = {}

    if (val?.paymentGatewayName == '') {
      errors.paymentGatewayName = 'Please enter Gateway Name'
    }
    if (val?.accountName == '') {
      errors.accountName = 'Please enter Account Name'
    }
    if (val?.email !== '') {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val?.email)) {
        errors.email = 'Please enter valide Email'
      }
    }

    setError({...errors})

    return errors
  }
  useEffect(() => {
    setPaymentMethod({...paymentMethod, ...edit})
    setError({})
  }, [edit])
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Payment Gateway Management</h2>
        </div>
        <div className='modal-body px-20 '>
          <div className='row justify-content-center m-2 p-3'>
            <div className='mb-3'>
              <label className=' col-form-label required fw-bold fs-6'>Gateway Name</label>
              <input
                value={paymentMethod?.paymentGatewayName}
                onChange={(e: any) =>
                  setPaymentMethod({...paymentMethod, paymentGatewayName: e.target.value})
                }
                className='form-control-solid form-control'
                placeholder='Gateway Name'
              />
              {error?.paymentGatewayName && (
                <span className='text-danger'>{error?.paymentGatewayName}</span>
              )}
            </div>
            <div className='mb-3'>
              <label className=' col-form-label required fw-bold fs-6'>Account Name</label>
              <input
                value={paymentMethod?.accountName}
                onChange={(e: any) =>
                  setPaymentMethod({...paymentMethod, accountName: e.target.value})
                }
                className='form-control-solid form-control'
                placeholder='Account Name'
              />
              {error?.accountName && <span className='text-danger'>{error?.accountName}</span>}
            </div>
            <div className='mb-3'>
              <label className=' col-form-label  fw-bold fs-6'>Email</label>
              <input
                value={paymentMethod?.email}
                onChange={(e: any) => setPaymentMethod({...paymentMethod, email: e.target.value})}
                className='form-control-solid form-control'
                placeholder='Email'
              />
              {error?.mobile && <span className='text-danger'>{error?.mobile}</span>}
            </div>
            <div className='mb-3'>
              {/* <label className='col-lg-4 col-form-label fw-bold fs-6'>Allow Marketing</label> */}

              <div className='col-lg-8 d-flex align-items-center mt-5'>
                <div className='form-check form-check-solid form-switch fv-row'>
                  <input
                    className='form-check-input w-45px h-30px'
                    type='checkbox'
                    id='allowmarketing'
                    checked={paymentMethod.status == 'active'}
                    onChange={() => {
                      let val = paymentMethod.status == 'active' ? 'inactive' : 'active'
                      setPaymentMethod({...paymentMethod, status: val})
                    }}
                  />
                  <label className='form-check-label'></label>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-md fs-7 gray_bg_purple me-2'
              >
                Cancel
              </button>
            </div>
            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateNewPaymentGateway
